
const isDefinedGlobally = () => {
  return typeof VeeValidate !== 'undefined';
};

const formatFileSize = (size) => {
  const units = ['Byte', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
  const threshold = 1024;
  size = Number(size) * threshold;
  const i = size === 0 ? 0 : Math.floor(Math.log(size) / Math.log(threshold));
  return `${(size / Math.pow(threshold, i)).toFixed(2) * 1} ${units[i]}`;
};

const messages = {
  after: (field, [target]) => `Feltet må være etter ${target}.`,
  alpha_dash: (field) =>
    `Feltet kan bare inneholde alfanumeriske tegn, samt bindestrek og understrek.`,
  alpha_num: (field) => `Feltet kan bare inneholde alfanumeriske tegn.`,
  alpha_spaces: (field) =>
    `Feltet kan bare inneholde alfanumeriske teng og mellomrom.`,
  alpha: (field) => `Feltet kan bare inneholde bokstaver.`,
  before: (field, [target]) => `Feltet må være før ${target}.`,
  between: (field, [min, max]) => `Feltet må være imellom ${min} og ${max}.`,
  confirmed: (field) => `Feltet kan ikke bekreftes.`,
  credit_card: (field) => `Kortnummeret er ugyldig.`,
  date_between: (field, [min, max]) =>
    `Feltet må være imellom ${min} og ${max}.`,
  date_format: (field, [format]) =>
    `Datoen må være i følgende format: ${format}.`,
  decimal: (field, [decimals = "*"] = []) =>
    `Feltet må kun inneholde tall samt kan inneholde ${
      decimals === "*" ? "" : decimals
    } desimaler.`,
  digits: (field, [length]) =>
    `Feltet må kun inneholde tall og inneholde nøyaktig ${length} siffer.`,
  dimensions: (field, [width, height]) =>
    `Feltet må være ${width} ganger ${height} piksler.`,
  email: (field) => `Feltet må inneholde en gyldig e-postadresse.`,
  ext: (field) => `Feltet må være en gyldig fil.`,
  image: (field) => `Feltet må være et bilde.`,
  included: (field) => `Feltet må være en gyldig verdi.`,
  ip: (field) => `Feltet må være en gyldig IP Adresse.`,
  max: (field, [length]) => `Feltet kan ikke være lengre enn ${length} tegn.`,
  max_value: (field, [max]) => `Feltet må være ${max} eller mindre.`,
  mimes: (field) => `Feltet må ha en gyldig filtype.`,
  min: (field, [length]) => `Feltet må være minst ${length} tegn.`,
  min_value: (field, [min]) => `Feltet må være ${min} eller mer.`,
  excluded: (field) => `Feltet må være en gyldig verdi.`,
  numeric: (field) => `Feltet kan bare inneholde siffer.`,
  regex: (field) => `Feltet sin formatering er ugyldig.`,
  required: (field) => `Feltet er obligatorisk.`,
  size: (field, [size]) => `Feltet må være mindre enn ${formatFileSize(size)}.`,
  url: (field) => `Feltet er ikkje en gyldig URL.`,
  length: (field, [length, max]) => {
    if (max) return `Feltet må inneholde mellom ${length} og ${max} tegn.`;

    return `Feltet må være ${length} tegn langt.`;
  },
};

const locale = {
	name: 'nb_NO',
	messages,
	attributes: {}
};

if (isDefinedGlobally()) {
	// eslint-disable-next-line
	VeeValidate.Validator.localize({ [locale.name]: locale });
}

export default locale;
